<script>
    import HeaderProgramSection from './header_program_section.svelte';
    import Footer from '../landing_page/footer.svelte';
    import ForSection from './for_section.svelte';
    import {
        corporative,
        corporativeForSection,
    } from './program_data.js';
    const {title} = rpcjs.props;
    title.set('Corporative | Program');
    const data = [
        {
            img: '/images/corporative_section/Intro to Digital Transformation.svg',
            description: 'Intro to Digital Transformation',
            width: '4.401vw',
            left: '2.9vw',
        },
        {
            img: '/images/corporative_section/Business Model and Process.svg',
            description: 'Business Model and Process',
            width: '7.677vw',
            left: '1.6vw',
        },
        {
            img: '/images/corporative_section/Cultural and Organizational Transformation.svg',
            description: 'Cultural and Organizational Transformation ',
            width: '3.839vw',
            left: '3.353vw',
        },
        {
            img: '/images/corporative_section/Challenges and Oppertunities.svg',
            description: 'Challenges and Opportunities',
            width: '4.959vw',
            left: '3.353vw',
        },
        {
            img: '/images/corporative_section/Strategy and Competition.svg',
            description: 'Strategy and Competition',
            width: '4.400vw',
            left: '3.353vw',
        },
        {
            img: '/images/corporative_section/Brand Storytelling in a Digital World.svg',
            description: 'Brand Storytelling in a Digital World',
            width: '2.530vw',
            left: '4vw',
        },
        {
            img: '/images/corporative_section/Accelerating Marketing Execution through Agile Marketing.svg',
            description:
                'Accelerating Marketing Execution through Agile Marketing',
            width: '4.169vw',
            left: '3vw',
        },
        {
            img: '/images/corporative_section/Platform-based Competition.svg',
            description: 'Platform-based Competition',
            width: '4.037vw',
            left: '3.2vw',
        },
        {
            img: '/images/corporative_section/Changing Competitive Imperatives.svg',
            description: 'Changing Competitive Imperatives',
            width: '3.805vw',
            left: '3.39vw',
        },
        {
            img: '/images/corporative_section/Platform Wars; Winning from Behind.svg',
            description: 'Platform Wars; Winning from Behind',
            width: '3.750vw',
            left: '3.39vw',
        },
        {
            img: '/images/corporative_section/Understanding Customers and Generating Insights.svg',
            description: 'Understanding Customers and Generating Insights',
            width: '3.761vw',
            left: '3.39vw',
        },
        {
            img: '/images/corporative_section/Customer Journey and Content Strategy.svg',
            description: 'Customer Journey and Content Strategy',
            width: '4.779vw',
            left: '3.39vw',
        },
        {
            img: '/images/corporative_section/Customer Segmentation and Behavioral Marketing.svg',
            description: 'Customer Segmentation and Behavioral Marketing',
            width: '6.845vw',
            left: '1.9vw',
        },
        {
            img: '/images/corporative_section/Automation and Artificial Intelligence.svg',
            description: 'Automation and Artificial Intelligence ',
            width: '3.574vw',
            left: '3.5vw',
        },
        {
            img: '/images/corporative_section/Operating During Uncertanity.svg',
            description: 'Operating During Uncertanity',
            width: '3.947vw',
            left: '3vw',
        },
    ];
    const duringProgram = [
        {
            src: ' ',
            title: ' ',
            description: ' ',
        },
        {
            src: '/images/corporative_section/Group 408.svg',
            title: 'Speakers',
            description:
                ' Learn from all-stars from companies such as Uber, American Express, Stanford, Google, etc.',
        },
        {
            src: '/images/corporative_section/Group 471.svg',
            title: 'Mentors',
            description:
                ' Receive guidance and introductions from personalized mentors who are experts in their fields',
        },
        {
            src: '/images/corporative_section/Group 470.svg',
            title: 'Workshops',
            description:
                '  Interactive, hands-on workshops such as Prototyping, Lean Startup Methodology',
        },
        {
            src: '/images/corporative_section/Group 402.svg',
            title: 'Company Visits',
            description:
                'Tour companies such as Google, Facebook, Tesla, 500 Startups, Uber, etcetera',
        },
    ];
    const duringProgramMbl = [
        {
            src: '/images/corporative_section/Group 408.svg',
            title: 'Speakers',
            description:
                ' Learn from all-stars from companies such as Uber, American Express, Stanford, Google, etc.',
        },
        {
            src: '/images/corporative_section/Group 471.svg',
            title: 'Mentors',
            description:
                ' Receive guidance and introductions from personalized mentors who are experts in their fields',
        },
        {
            src: '/images/corporative_section/Group 470.svg',
            title: 'Workshops',
            description:
                '  Interactive, hands-on workshops such as Prototyping, Lean Startup Methodology',
        },
        {
            src: '/images/corporative_section/Group 402.svg',
            title: 'Company Visits',
            description:
                'Tour companies such as Google, Facebook, Tesla, 500 Startups, Uber, etcetera',
        },
    ];
    const list = [
        {
            description:
                'Build the necessary knowledge, experience, and leadership ' +
                ' skills to bring innovation back to your company and team. ',
            i: 'i',
        },
        {
            description:
                'Offer investment opportunities to participants from mentors and angel investors',
            i: 'ii',
        },
        {
            description:
                'Offer deal flow opportunities for the participants’ companies',
            i: 'iii',
        },
        {
            description:
                'Create new partnerships with startups and corporations for participants',
            i: 'iv',
        },
        {
            description:
                'Expand the participants’ networks in Silicon Valley and around the world.',
            i: 'v',
        },
    ];
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<HeaderProgramSection
    data={corporative}
    widthDescription="66vw"
    marginTop="2.5vw"
    lineHeightMbl="11.111vw"
    TopMbl="98vw"
    hrWidth="70.9
    29vw"
    lineHeight="12.299vw"
    boxTop = '38.5vw'
    colors="white"
    letterSpace="0.02vw"
    headingTop="-13vw"
    wordSpace="0.2vw"
    headingLeft="0.01vw"
    subheadingMbl="91.333vw"
    discTop="37vw"
/>
<div class="desktop">
    <div style="position: relative;">
        <div class="circle" />
        <div class="circle" />
        <div class="circle" />
    </div>
    <div style="width: 88.815vw;margin:11.905vw auto;padding:0 1vw;">
        <div style="display: flex;align-items:center">
            <h1
                class="section1"
                style="color: rgb(0, 32, 75);
                font-size: 1.191vw;
                margin-right: 5vw;
                opacity: 0.3;
                margin-top: 0.65vw;"
            >
                01
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
            >
                Curriculum Highlights
            </h1>
        </div>
        <div
            style="border-radius:1.2vw;box-shadow: 0vw 0.265vw 2.912vw rgba(0, 32, 75, 0.2);margin-top:5vw;"
        >
            {#each data as data}
                <div class="content-holder">
                    <div
                        style="display: inline-flex;align-items: center;padding:3vw;width:100%"
                    >
                        <div
                            class="img-wrraper-logo"
                            style="width: 3.5vw;margin-right: 5vw;"
                        >
                            <img
                                style="width:{data.width};margin-left: {data.left};"
                                src={data.img}
                                alt=""
                                width="100%"
                            />
                        </div>
                        <div>
                            <h1
                                class="section1list"
                                style="font-weight: 600;
                                font-size: 1.985vw;
                                color: rgba(0, 32, 75, 1);
                                margin-left: 9vw;"
                            >
                                {data.description}
                            </h1>
                        </div>
                    </div>
                </div>
            {/each}
        </div>
    </div>
    <div style="width: 88.815vw;margin:auto;padding:0 1vw;">
        <div style="display: flex;align-items:center">
            <h1
                class="section1"
                style="
                color: rgb(0, 32, 75);
                font-size: 1.191vw;
                margin-right: 6.548vw;
                opacity: 0.3;
                margin-top: 0.65vw;
            "
            >
                02
            </h1>
            <h1
                style="color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
            >
                What Happens During the Program?
            </h1>
        </div>
        <div
            style="display: flex;
        text-align:center;    
        margin-top: 3vw;
        margin-left: 2vw;"
        >
            {#each duringProgram as data}
                <div class="content_table">
                    <div style="width: 3vw;height: 3vw;margin: auto;">
                        <img src={data.src} alt="" width="100%" />
                    </div>
                    <div style="">
                        <h1
                            style="font-size:1.191vw;margin:1.919vw 0vw; color:rgba(0, 32, 75, 1); font-weight:500;"
                        >
                            {data.title}
                        </h1>
                    </div>
                    <div style="">
                        <h1
                            style="color:rgba(0, 32, 75, 1);
                        font-size:1.059vw; width: 16.545vw;"
                        >
                            {data.description}
                        </h1>
                    </div>
                </div>
            {/each}
        </div>
    </div>
</div>
<div class="mobile">
    <div
        style="display: flex;align-items:center; margin-left:5.556vw; margin-top: 24.766vw; margin-bottom: 5vw; "
    >
        <h1
            class="section1"
            style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;"
        >
            01
        </h1>
        <h1
            class="section-title"
            style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;text-align: center;"
        >
            Curriculum Highlights
        </h1>
    </div>
    <div
        style="border-radius:3vw;box-shadow: 0vw 0.265vw 2.912vw rgba(0, 32, 75, 0.2);margin-top:7vw; width: 91.111vw;
            margin: auto;"
    >
        {#each data as data}
            <div class="content-holder_mbl">
                <div
                    style="display: inline-flex;align-items:center;height: 22.664vw;"
                >
                    <div
                        class="img-wrraper-logo_mbl"
                        style="width: 10vw;margin: auto 5.056vw auto 8.056vw;"
                    >
                        <img src={data.img} alt="" width="100%" />
                    </div>
                    <div>
                        <h1
                            class="section1list"
                            style="font-size: 3.889vw; width:54.907vw;    line-height: 4.706vw;"
                        >
                            {data.description}
                        </h1>
                    </div>
                </div>
            </div>
        {/each}
    </div>
    <div
        style="display: flex;align-items:center; margin-left:5.556vw; margin-top: 21.446vw; margin-bottom: 5vw; "
    >
        <h1
            class="section1"
            style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;"
        >
            02
        </h1>
        <h1
            class="section-title"
            style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;margin-top:8vw;"
        >
            What Happens During <br /> the Program?
        </h1>
    </div>
    <div style="text-align:center;margin:10vw auto">
        {#each duringProgramMbl as data}
            <div class="content_table_mbl">
                <div style="width: 12vw;height: 12vw;margin: auto;">
                    <img src={data.src} alt="" width="100%" />
                </div>
                <div style="">
                    <h1
                        style="font-size:3.889vw; font-weight:500; margin:3.612vw 0vw"
                    >
                        {data.title}
                    </h1>
                </div>
                <div style="">
                    <h1
                        style="font-size:3.056vw; width:60.278vw; text-align:center;margin:auto;"
                    >
                        {data.description}
                    </h1>
                </div>
            </div>
        {/each}
    </div>
</div>
<div style="margin-top: 0.5vw; margin-bottom: 2.648vw;">
    <ForSection
        data={corporativeForSection}
        headingTop="16.6vw"
        marginFor="-7vw"
        headingLeft="5.95vw"
    />
</div>

<div class="desktop">
    <div
        style=" width: 88.815vw;
        margin: 12.566vw auto;
        padding: 0px 1vw;
        margin-top: 16.648vw;"
    >
        <div style="display: flex;">
            <h1
                style="color: rgb(0, 32, 75);
            font-size: 1.191vw;
            margin-right: 9.001vw;
            margin-top: -0.65vw;
            opacity: 0.3;"
            >
                04
            </h1>
            <div class="circle-yellow">
                <h1
                    style="    color: rgb(0, 32, 75);
                font-size: 1.985vw;
                text-transform: uppercase;
                margin-left: 0.466vw;"
                >
                    Benefits of this Program
                </h1>
                <div
                    style="         
                    width: 46.7vw;
                    margin-left: 18.989vw;
                    margin-top: 2.447vw;
                    color: rgb(0, 32, 75);
                    line-height: 2.050vw; "
                >
                    <p
                        style="    font-size: 1.323vw;
                text-align: justify;"
                    >
                        This program is for executives and corporate innovation
                        managers looking to upskill or stay on trend with the
                        most up to date learning from Silicon Valley founders
                        and entrepreneurial academics. We provide insights on
                        upcoming technology, its impact, and future-forward
                        thinking to innovate with a 10X mentality. The learning
                        is supplemented with both practical learning and
                        tactical application in both corporate innovation and
                        venture capital investment. Leave feeling confident
                        about your innovation strategy.
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div
        style="background: linear-gradient(1.05deg, rgb(0, 32, 75) 25.19%, rgb(0, 66, 155) 99.35%);padding:1vw; margin-bottom: -0.2vw;"
    >
        <div style="width: 88.815vw;margin:7vw auto 0;padding:0 1vw;">
            <div style="display: flex;align-items:center">
                <h1
                    style="color:white;font-size:1.985vw;margin-right:5vw;opacity: 0.7;"
                >
                    05
                </h1>
                <h1
                    style="color:white;font-size:2.068vw;text-transform: uppercase;"
                >
                    Why Join This Program
                </h1>
            </div>
            <div style="display:flex;justify-content:space-between;">
                <div
                    style="    width: 28.245vw;
                    height: -55.585vw;
                    border-radius: 30vw;
                    margin-top: 2.295vw;
                    margin-left: 4vw;"
                >
                    <img
                        src="/images/corporative_section/IMG_20180410_171154 1.png"
                        alt=""
                        width="100%"
                    />
                </div>
                <div
                    style="    width: 40vw;
                margin-top: 3.2vw;"
                >
                    {#each list as data}
                        <div style="display: flex;">
                            <div
                                style="padding-top: 0.7vw; width:2vw; text-align: end;"
                            >
                                <p class="footer-count">{data.i}</p>
                            </div>
                            <div style="margin-left: 3.5vw;margin-bottom: 1vw">
                                <p class="footer-text">
                                    {data.description}
                                </p>
                            </div>
                        </div>
                    {/each}
                </div>
            </div>
            <div
                style=" text-align: center;
            margin-top: 5vw;"
            >
                <button
                    class="btn-css"
                    on:click={() => (location.href = '/applyProgram')}
                >
                    APPLY NOW
                </button>
            </div>
        </div>
    </div>
</div>
<div class="mobile">
        <div style="display: flex; margin-left:5.556vw;margin-top:33.666vw;margin-bottom: 12.379vw;">
            <div>
                <h1
                    class="section1"
                    style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;margin-top:-0.8vw;"
                >
                    04
                </h1>
            </div>
            <div class="circle-yellow">
                <div style="position: absolute;left: -7.5vw;
                width: 80vw;
                top: 13.612vw;">
                    <h1
                    style="color: rgb(0, 32, 75);
                    font-size: 5.556vw;
                    text-transform: uppercase;
                    margin-left: 0.466vw;"
                    >
                    Benefits of this Program
                </h1>
                </div>
               
                <div
                    style="         
                    width: 73.612vw;
                    margin-left: -6.556vw;
                    margin-top: 28.058vw;
                    color: rgb(0, 32, 75);
                    line-height: 5.000vw; "
                >
                    <p
                        style="    font-size: 3.056vw;
                text-align: justify;"
                    >
                        This program is for executives and corporate innovation
                        managers looking to upskill or stay on trend with the
                        most up to date learning from Silicon Valley founders
                        and entrepreneurial academics. We provide insights on
                        upcoming technology, its impact, and future-forward
                        thinking to innovate with a 10X mentality. The learning
                        is supplemented with both practical learning and
                        tactical application in both corporate innovation and
                        venture capital investment. Leave feeling confident
                        about your innovation strategy.
                    </p>
                </div>
            </div>
            
        </div>
    <div
        style="background: linear-gradient(1.05deg, #00204B 50.19%, #00429B 99.35%);"
        >
        <div style="display: flex;align-items:center;    padding-top: 21.234vw;">
            <h1
                style="color:white;font-size:2.778vw;margin-right:7.061vw;opacity: 0.7;margin-left:5.556vw;"
            >
                05
            </h1>
            <h1
                style="color:white;font-size:5.556vw;text-transform: uppercase;"
            >
                Why Join This Program
            </h1>
        </div>
        <div style="width:97.834vw;margin:auto;border-radius: 30vw;margin-top:-5vw;">
            <img
                src="/images/corporative_section/why_mobile.png"
                alt=""
                width="100%"
            />
        </div>
                <div
                    style="  margin-top: 8.834vw;">
                    {#each list as data}
                        <div style="display: flex;justify-content: center;">
                            <div
                                style=" width:5vw; text-align: end;"
                            >
                                <p class="footer-count">{data.i}</p>
                            </div>
                            <div style="margin-left: 7.808vw;">
                                <p class="footer-text">
                                    {data.description}
                                </p>
                            </div>
                        </div>
                    {/each}
                </div>
        <div style="text-align: center;margin-top:7.12vw;">
            <button
                on:click={() => (location.href = '/applyProgram')}
                style="padding: 2vw 11vw; border-radius:8.333vw;border:none;background-color:#F7E05F;font-size:3.611vw;"
                >Apply</button
            >
        </div>
    </div>
</div>
<Footer />

<style>
    .footer-count {
        font-weight: bold;
        font-size: 1.7vw;
        font-family: "inter";
        color: #88bce5;
    }
    .footer-text {
        font-size: 1.323vw;
        font-weight: 500;
        font-family: "inter";
        width: 29vw;
        margin-top: 1vw;
        color: white;
    }
    .btn-css {
        background-color: #f7e05f;
        border-radius: 1.984vw;
        color: #00204b;
        font-weight: 500;
        border: none;
        width: 13.228vw;
        height: 3.64vw;
        font-size: 0.927vw;
    }
    .btn-css:hover {
        background-color: transparent;
        border: 0.194vw solid white;
        color: white;
        width: 13.228vw;
        height: 3.64vw;
        font-weight: 500;
        font-size: 0.927vw;
    }
    /* li::marker {
        font-size: 1.2vw;
        color: #88bce5;
        font-weight: 900;
    } */
    .content_table {
        width: 20vw;
        padding: 4vw 2vw;
        border-right: 0.2vw solid rgba(124, 193, 255, 1);
        border-top: 0.2vw solid rgba(124, 193, 255, 1);
        border-bottom: 0.2vw solid rgba(124, 193, 255, 1);
    }
    .content_table:nth-child(1) {
        width: 10vw;
    }
    .content_table:nth-child(5) {
        border-top-right-radius: 1vw;
        border-bottom-right-radius: 1vw;
    }
    .content_table_mbl {
        width: 89.722vw;
        height: 50.28vw;
        border-right: 0.833vw solid #a7d0f5;
        border-top: 0.833vw solid #a7d0f5;
        padding-top: 7.009vw;
        margin: auto;
    }
    .content_table_mbl:nth-child(1) {
        border-top-right-radius: 8vw;
    }
    .content_table_mbl:nth-child(2) {
        width: 83vw;
        margin-left: 12vw;
        padding-right: 10vw;
    }
    .content_table_mbl:nth-child(3) {
        width: 83vw;
        margin-left: 12vw;
        padding-right: 10vw;
        border-bottom: 0.833vw solid #a7d0f5;
    }
    .content_table_mbl:nth-child(4) {
        border-bottom-right-radius: 8vw;
        border-bottom: 0.833vw solid #a7d0f5;
        border-top: none;
    }
    .content-holder {
        height: 9.53vw;
    }
    .content-holder:nth-child(odd) {
        background-color: rgba(226, 242, 255, 1);
    }
    .content-holder:nth-child(1) {
        border-top-left-radius: 1vw;
        border-top-right-radius: 1vw;
    }
    .circle-yellow {
        width: 59.166vw;
        height: 30.179vw;
        padding: 5vw 0 0 4vw;
        border: 0.199vw solid rgb(124 193 255 / 20%);
        border-top-right-radius: 1vw;
        border-bottom-right-radius: 1vw;
        border-left: none;
        position: relative;
    }
    .circle-yellow::before {
        content: " ";
        position: absolute;
        top: -1.09vw;
        left: 2vw;
        height: 1.919vw;
        width: 1.919vw;
        background-color: rgba(247, 224, 95, 1);
        border-radius: 50%;
    }
    .circle {
        height: 24.818vw;
        width: 24.818vw;
        border-radius: 50%;
        opacity: 40%;
        position: absolute;
        left: -20vw;
        top: -7vw;
        background-color: rgba(60, 136, 195, 0.33);
    }
    .circle:nth-child(2) {
        top: 3vw;
    }
    .circle:nth-child(3) {
        top: 15vw;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    /* .content-holder_mbl {
        height: 22.5vw;
    } */
    .content-holder_mbl:nth-child(odd) {
        background-color: rgba(226, 242, 255, 1);
    }
    .content-holder_mbl:nth-child(1) {
        border-top-left-radius: 3vw;
        border-top-right-radius: 3vw;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        /* li::marker {
            font-size: 3.556vw !important;
        } */
        .footer-count {
        font-weight: bold;
        font-size: 5.556vw;
        font-family: "inter";
        color: #88bce5;
    }
    .footer-text {
        font-size: 3.056vw;
        font-weight: 500;
        font-family: "inter";
        width: 69vw;
        margin-top: 1vw;
        line-height: 5.556vw;
        color: white;
        margin-bottom: 9.009vw
    }
        .circle-yellow {
        width:64.306vw;
        height: 99.444vw;
        padding: 5vw 0 0 4vw;
        border: 0.833vw solid #a7d0f5;
        border-top-right-radius: 7vw;
        border-bottom-right-radius: 7vw;
        border-left: none;
        position: relative;
    }
    .circle-yellow::before {
        content: " ";
        position: absolute;
        top: -2.4vw;
        left: 6vw;
        height: 4.166vw;
        width: 4.166vw;
        background-color: rgba(247, 224, 95, 1);
        border-radius: 50%;
    }
    }
</style>
